import { Unstable_Grid2 as Grid } from '@mui/material';

import { InfoField } from '@occc/ui-design-system';

type LocationScanDataMSADetailsProps = {
  rjrAccountNumber: string | null;
  rjrAutoOffersEnabled: boolean | null;
  rjrRbdsCode: string | null;
};

export const LocationScanDataMSADetails = (props: LocationScanDataMSADetailsProps) => {
  const { rjrAccountNumber, rjrAutoOffersEnabled, rjrRbdsCode } = props;

  return (
    <Grid container spacing={2}>
      <Grid xs={3}>
        <InfoField label='RJR Account Number' value={rjrAccountNumber} />
      </Grid>
      <Grid xs={3}>
        <InfoField label='RJR RBDS Code' value={rjrRbdsCode} />
      </Grid>
      <Grid xs={3}>
        <InfoField label='RJR Auto Offers' value={rjrAutoOffersEnabled ? 'Enabled' : 'Disabled'} />
      </Grid>
    </Grid>
  );
};
